import dateFormat from 'dateformat'
import { truncate, capitalize } from 'lodash-es'
import MarkdownIt from 'markdown-it'

import { friendlyFileSize } from './utils'

const MI = new MarkdownIt({
  breaks: true,
})

const filters = {
  longDate(dateString: string): string {
    if (!dateString) return ''
    try {
      const d = new Date(dateString)
      return dateFormat(d, 'dd mmm yyyy HH:MM Z')
    } catch {
      return dateString
    }
  },
  fullDateTime(dateString: string, noneValue: string = 'Not set'): string {
    if (!dateString) return noneValue
    try {
      const d = new Date(dateString)
      return dateFormat(d, 'dd mmm yyyy HH:MM')
    } catch {
      return dateString
    }
  },
  shortDate(dateString: string): string {
    if (!dateString) return ''
    try {
      const d = new Date(dateString)
      return dateFormat(d, 'dd mmm yyyy')
    } catch {
      return dateString
    }
  },
  truncate(theString: string, toLength = 30): string {
    return truncate(theString, { length: toLength })
  },
  fileSize(size: number): string {
    return friendlyFileSize(size)
  },
  underscoredToTitle(underscored_text: string): string {
    if (!underscored_text) return ''
    return underscored_text.split('_').map(capitalize).join(' ')
  },
  yesNo(boolish: unknown): string {
    return boolish ? 'Yes' : 'No'
  },
  underToCamel(underscoredText: string): string {
    function capitaliseFirstLetter(input: string) {
      return input.charAt(0).toUpperCase() + input.toLowerCase().slice(1)
    }
    if (!underscoredText) {
      return ''
    }
    return underscoredText.split('_').map(capitaliseFirstLetter).join(' ')
  },
  markdown(mdText: string): string {
    return MI.render(mdText)
  },
  markdownInline(mdText: string): string {
    return MI.renderInline(mdText)
  },
  pretty(jsObject: object): string {
    return JSON.stringify(jsObject, null, 2)
  },
  camelToTitle(camelText: string): string {
    if (!camelText) return ''
    return camelText
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .trim()
  },
}

export default filters

// Export the type of the filters object
export type FiltersType = typeof filters
